import AuthCookie from './AuthCookie';
import BaseRest from './BaseRest';
import Environment from './Environment';

class BaseApi extends BaseRest {
  getPath(path) {
    return this.tryFetch(() => super.getPath(path));
  }

  get(path, query) {
    return this.tryFetch(() => super.get(path, query));
  }

  post(path, requestBody) {
    return this.tryFetch(() => super.callPost(path, requestBody));
  }

  put(path, requestBody) {
    return this.tryFetch(() => super.callPut(path, requestBody));
  }

  async tryFetch(method) {
    if (!AuthCookie.getToken()) {
      await this.getToken();
    }

    let response = await method().catch(async err => {
      if (err.status === 401 || (err.message || '').includes('token')) {
        await this.getToken();
        return await method().catch(error => {
          if (err.status === 401 || (err.message || '').includes('token')) {
            err.unauthorized = true;
          }
          return Promise.reject(err);
        });
      } else {
        return Promise.reject(err);
      }
    });

    return response;
  }

  getToken() {
    const token = this.getQueryStringParam('token');
    const b64host = this.getQueryStringParam('b64host');
    let host;

    if (b64host) {
      host = atob(b64host);
    }

    if (!host) {
      host = AuthCookie.getAuthHost();
    } else {
      AuthCookie.setAuthHost(host);
    }

    let url = Environment.authApi
      .replace('<token>', token)
      .replace('<host>', host);
    return fetch(url, this.buildOptions('GET')).then(response => {
      AuthCookie.setToken(response.auth_token);
      return response;
    });
  }

  getQueryStringParam(name) {
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(window.location.href);
    if (!results || !results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}

export default BaseApi;



// WEBPACK FOOTER //
// ./src/api/BaseApi.js